import { combineReducers } from 'redux';

import currentBranchId from './currentBranchId';
import branches from './branches';
import choices from './choices';
import slots from './slots';

const rootReducer = combineReducers({
    branches,
    choices,
    currentBranchId,
    slots
});

export default rootReducer;
